__turbopack_context__.v({
  "content": "modal-module__Ja7IYG__content",
  "header": "modal-module__Ja7IYG__header",
  "overlay": "modal-module__Ja7IYG__overlay",
  "title": "modal-module__Ja7IYG__title",
});
